<template>
  <div class="master-uom-detail-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong v-if="item.id == ''">{{ $t('create') }}</strong>
              <strong v-else>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.id != null">
              <b-col cols="6" align-self="center">
                <b-form-group v-bind:label="$t('from_uom_name')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.from_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('from_uom_qty')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.from_uom_qty">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('to_uom_name')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.to_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('to_uom_qty')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.to_uom_qty">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('conversion_rate')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.conversion_rate">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-model="item.is_active" v-bind:checked="item.is_active" :value="1" :uncheckedValue="0"/>
                </b-form-group>
              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
<!--              <b-button variant="success" v-on:click="updateItem" v-if="id != null && $auth.check(model + '.update')"><i-->
              <b-button variant="success" v-on:click="updateItem" v-if="id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--                <b-button variant="success" v-on:click="createItem" v-if="id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .qty_uom {
    margin-top: -190px;
  }
</style>
<script>
  import cSwitch from '../../../../components/Switch'
  import {getMasterUomList, get, create, update} from '@/api/master_uom_detail'

  export default {
    name: 'MasterUomDetailForm',
    props: {
      id: {
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_uom_detail',
        item: {
          id: '',
          from_uom_id: '',
          to_uom_id: '',
          from_uom_qty: '',
          to_uom_qty: '',
          conversion_rate: '',
          name: '',
          is_active: 1
        },
        uoms: [],
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Get list units
       */
      getListUoms() {
        this.$Progress.start()
        getMasterUomList().then((response) => {
          this.uoms = []
          for (let i in response.data.data) {
            this.uoms.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get details of object
       */
      getDetails() {
        this.$Progress.start()
        let params = {
          id: this.id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.from_uom_id = this.item.from_uom_id.value
        param.to_uom_id = this.item.to_uom_id.value
        update(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.from_uom_id = this.item.from_uom_id.value
        param.to_uom_id = this.item.to_uom_id.value
        create(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      this.getListUoms()
      if (this.id != null) {
        this.getDetails()
      } else {
        this.item.id = ''
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_uom_detail/Form.vue